import React, { useRef, useState } from "react"

import SaasTooltip from "../SaasTooltip"
import CopyBox from "../CopyBox"
import TipCodeSnippets from "../SaasDevEnvTabs/TipCodeSnippets"

import "../../../style/saas-setup-tab.module.css"
import ApiKeyList from "../SaasDevEnvTabs/ApiKeyList"
import { DevSetupTabProps } from "../SaasDevEnvTabs/DevSetupTab"

type ProdSetupTabProps = {
  serviceApiKey: string;
} & Omit<DevSetupTabProps, "accessPostgreSQLDBAction" | "visitDocsAnalytics">

const ProdSetupTab = (props: ProdSetupTabProps) => {
  const tipRef = useRef(null)
  const editRef = useRef(null)

  return (
    <div className="setup-tab">
      <p>
        You can run the production env for <b>free for up to 5,000 monthly active users</b>. A user is active for a month if they created or refreshed their session during that month.
      </p>

      <hr />

      <div className="setup-tab__connection">
        <p className="setup-tab__connection__title">
          <span className="setup-tab__connection__title__text">
            Connecting to a production instance
          </span>

          <img
            src="static/assets/dashboard/blue-question-round.png"
            alt="Connection tips"
            ref={tipRef}
            className="blue-clickable-image"
          />
        </p>

        <p className="setup-tab__connection__details">
          Put these credentials when calling SuperTokens init function on your backend:
        </p>

        <div className="setup-tab__connection__creds">
          <div className="setup-tab__connection__creds__cred">
            <p className="setup-tab__connection__creds__cred__key">Core connectionURI:</p>
            <CopyBox
              copyCallback={() => props.copyCredentialCallback("prod", "connectionURI")}
              value={props.host}
            />
          </div>
          <div className="setup-tab__connection__creds__cred">
            <p className="setup-tab__connection__creds__cred__key">Core API key:</p>
            <ApiKeyList apiKeys={props.apiKeys}
              copyCredentialCallback={() => props.copyCredentialCallback("prod", "API key")}
              createApiKeyFunction={props.createApiKeyFunction}
              deleteApiKeyFunction={props.deleteApiKeyFunction} allowEditing />
          </div>
          <div className="setup-tab__connection__creds__cred">
            <p className="setup-tab__connection__creds__cred__key">SMS API key:</p>
            <CopyBox
              copyCallback={() => props.copyCredentialCallback("prod", "SMS API key")}
              value={props.serviceApiKey}
            />
          </div>
        </div>

        <hr />

        <div
          ref={editRef}
          style={{
            position: "relative",
            zIndex: 0,
            maxWidth: "fit-content",
          }}>
          <button
            className="white-button"
            disabled={props.editConfigDisabled}
            onClick={props.configButtonClickAction}
            style={{
              zIndex: props.showEditDisabledTooltip ? -1 : undefined,
              position: "relative",
            }}
          >
            Edit configuration
          </button>
        </div>
        <div className="info-blue-container">
          <span className="info-blue-pill">Note</span>
          <p>
            Access to the Postgres database in the production environment is restricted due to security and data consistency reasons. However, if you require a database snapshot, please send us an <a href="mailto:support@supertokens.com?subject=Request for access to production Postgres database snapshot">Email request</a> from your registered email ID.
          </p>
        </div>
      </div>

      <SaasTooltip
        trigger="click"
        elementRef={tipRef}
        showTooltipCallback={props.connectMoreInfoCallback}
      >
        <TipCodeSnippets />
      </SaasTooltip>

      {
        props.showEditDisabledTooltip &&
        <SaasTooltip
          trigger="hover"
          elementRef={editRef}
          minHeight="50px"
          maxWidth="300px"
          minWidth="300px"
        >
          <span>To edit the configuration of this app refer to our docs <a style={{ color: "#FF9933" }} target="_blank" href="/docs/multitenancy/new-tenant#providing-additional-configuration-per-tenant">here</a></span>
        </SaasTooltip>
      }
    </div>
  )
}

export default ProdSetupTab
